class ApiEndpoints {
  static serverURL =
    // process.env.REACT_APP_SERVER_URL ||
    "https://server.ttrprogramming.com";
    // "https://dev.server.ttrprogramming.com";
  // "http://192.168.1.25:5000";
  static assetURL =
    // process.env.REACT_APP_ASSET_URL ||
    "https://assets.ttrprogramming.com";
  static baseApiURL = `${this.serverURL}/api/v1`;
  static baseAssetUrl = `${this.assetURL}`;
  static sitekey = "6LftJ5srAAAAABUDcNVKP-iShPRyQGaxZDfwJ_2D"

  //for client
  static client = `/client`;
  static clientLogin = `${this.client}/login`;
  static clientRegister = `${this.client}/register`;
  static forgetClientPassword = `${this.client}/forget-password`;
  static resetClientPasswords = `${this.client}/reset-password`;
  static clientProfile = `${this.client}/profile`;
  static changeClientProfile = `${this.client}/profile`;
  static changeClientPassword = `${this.client}/change-password`;
  static changeClientEmail = `${this.client}/change-email`;
  static fitnessReport = `/fitness-report/client`;
  //report
  static clientsummary = "/performance-summary/year"
  static clientdownloadreport = "/fitness-report/download/client"

}
export default ApiEndpoints;
